import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initCertifications(element) {
    const swiper = new Swiper(element.querySelector('.swiper-certifications'), {
        modules: [Navigation, Pagination],
        slidesPerView: 4,
        spaceBetween: 40,
        pagination: {
            type: 'fraction',
            el: element.querySelector('.pagination-swiper'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                navigation: {
                    nextEl: element.querySelector('.navmob .swiper-button-next'),
                    prevEl: element.querySelector('.navmob .swiper-button-prev'),
                },
            },
            680: {
                slidesPerView: 2.4,
                navigation: {
                    nextEl: element.querySelector('.navdesk .swiper-button-next'),
                    prevEl: element.querySelector('.navdesk .swiper-button-prev'),
                },
            },
            1024: {
                slidesPerView: 4,
                navigation: {
                    nextEl: element.querySelector('.navdesk .swiper-button-next'),
                    prevEl: element.querySelector('.navdesk .swiper-button-prev'),
                },
            },
        },
    });
}

function initAllCertifications() {
    document.querySelectorAll('.certifications').forEach(function (element) {
        initCertifications(element);
    });
}

domContentLoadEvent(initAllCertifications);
